import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<circle cx=\"10\" cy=\"10\" r=\"9\" fill=\"#BBBBBB\" />\n<rect x=\"6.46436\" y=\"5.0498\" width=\"12\" height=\"2\" rx=\"1\" transform=\"rotate(45 6.46436 5.0498)\" fill=\"white\" />\n<rect x=\"14.9497\" y=\"6.46484\" width=\"12\" height=\"2\" rx=\"1\" transform=\"rotate(135 14.9497 6.46484)\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol